<template>
  <v-data-table
    :headers="headers"
    mobile-breakpoint="0"
    :items="busStudents"
    :items-per-page="5"
    :options.sync="pagination"
    item-key="id"
    loading-text="Đang Tải"
    :loading="loading"
    sort-by="title"
    no-data-text="Không có dữ liệu"
    disable-sort
  >
    <template v-slot:[`item.student`]="{ item }">
      <CardStudentName :student="item.student" link />
    </template>
    <template v-slot:[`item.class`]="{ item }">
      <router-link
        style="text-decoration: none"
        :to="'/class/' + (item.student.currentClass && item.student.currentClass.id)"
      >
        {{ item.student.currentClass && item.student.currentClass.title }}
      </router-link>
    </template>
    <template v-slot:[`item.buses`]="{ item }">
      <div v-for="bus in item.buses" :key="bus.id" class="d-flex align-center">
        <router-link style="text-decoration: none; white-space: nowrap" :to="'/bus/' + bus.id"
          >{{ bus.name }}
        </router-link>
      </div>
    </template>
    <template v-slot:[`item.type`]="{}">
      <div>
        Tại nhà
      </div>
    </template>
    <template v-slot:[`item.phone`]="{ item }">
      {{ item.student && item.student.phone }}
    </template>
    <template v-slot:[`item.driver`]="{ item }">
      <router-link style="text-decoration: none" :to="'/teacher/' + get(item, 'bus.driver.id')">
        <div>{{ get(item, 'bus.driver.name') }}</div>
      </router-link>
      <div>{{ get(item, 'bus.driver.phone') }}</div>
    </template>
    <template v-slot:[`item.headTeacher`]="{ item }">
      <router-link style="text-decoration: none" :to="'/teacher/' + get(item, 'headTeacher.id')">
        <div>{{ get(item, 'headTeacher.name') }}</div>
      </router-link>
      <div>{{ get(item, 'headTeacher.phone') }}</div>
    </template>
    <template v-slot:[`item.action`]="{ item }">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title class="red--text" style="cursor: pointer" @click="deleteBusStudent(item.id)"
              >Xóa học sinh</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { get } from 'lodash'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { getTableHeaders } from './student-bus/headers'

export default {
  components: { CardStudentName },
  data() {
    return {
      selected: [],
      search: '',
      editDialog: false,
      title: '',
      busTableOptions: {},
      busStops: [],
      pagination: {},
      get
    }
  },
  computed: {
    ...mapState({
      busStudents: state => state.BusStudents.busStudents,
      loading: state => state.BusStudents.loading
    }),
    ...mapGetters('auth', ['profile']),
    headers() {
      const isDriver = get(this.profile, 'ownBus') != null
      const isHeadTeacher = get(this.profile, 'ownClasses', []).length > 0
      return getTableHeaders({ isDriver, isHeadTeacher })
    }
  },
  async created() {
    const params = {}
    this.find(params)
  },
  methods: {
    ...mapActions({
      deleteStudent: 'BusStudents/fetchBusStudents',
      fetchBusStudents: 'BusStudents/fetchBusStudents',
      getBusStudentByPagination: 'BusStudents/fetchBusStudents',
      find: 'BusStudents/find'
    }),
    deleteBusStudent(id) {
      this.$dialog.confirm({
        title: 'Xác nhận xóa HS khỏi DS đăng ký xe tuyến',
        text:
          'Hệ thống sẽ xóa học sinh khỏi mọi điểm dừng trên các tuyến đã đăng ký. Bạn có chắc chắn muốn thực hiện thao tác này?',
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: () => {
          this.deleteStudent(id)
        }
      })
    }
  }
}
</script>
